import React, { useEffect, useState } from 'react'
import axios from 'axios';
import queryString from 'query-string';
import TopTitle from './TopTitle';
import { Container, Row, Col } from 'react-bootstrap';
import { comma,instance } from './common';
import Bottom_menu from './Bottom_menu';


function totalPrice(data,discount) {
    let price = 0;
    data.forEach(function (v) {
        price += Number(v.s_member_price);
        if(v.c_option){
            JSON.parse(v.c_option).forEach(function(items){
                price += Number(items.price);
            });
        }
    });

    price =  price-discount;


    return comma(price);
}

function sendPrice(data) {
    let price = 0;
    data.forEach(function (v) {
        price += Number(v.s_member_price);
    });
    return price;
}

function totalCount(data) {

    return Number(data.length - 1);
}



// function SigongId({si_id,si_data,setSiData}){




//     let obj = {si_id:si_id}
//     useEffect(() => {

//         const fetchData = async () => {
//             axios.post('https://abys-service.co.kr:3001/sigong/id',obj).then(function(res){

//                 setSiData(res.data[0]);        
//             });

//         };

//         fetchData();

//     }, []);


//     const {si_name,si_address} = si_data;

//     return (
//         <>
//             <h3 className="font-weight-bold mb-3" id="si_name">{si_name}</h3>
//             <span id="si_address">{si_address}</span>
//         </>
//     )
// }


function ServiceId({ data, u_type, date,discount }) {

    let str = '';
    let s_cate = '';
    if (data.s_id) {
        str = JSON.parse(data.s_id);
        s_cate = str[0].s_cate;
    }

    console.log('ServiceId data : ', str)




    return (
        <>
            {
                str &&
                str.map(v => <div className="row p-0 mt-2 mb-5" key={v.s_id}>
                    <div className="col-4 p-0" id="s_img">
                        <div className="r_r_bg" style={{ backgroundImage: 'url(' + v.s_img + ')' }}></div>
                    </div>
                    <div className="col-8 pr-0">
                        <div className="font-weight-bold r_title mb-2" id="s_name">{v.s_name}</div>
                        {/* <div className="r_subtext mb-5" id="s_content"></div> */}
                        <div className="r_r_color font-weight-bold r_title" id="s_price">
                            {
                                u_type == '일반고객'
                                    ? comma(v.s_price)
                                    : comma(v.s_member_price)
                            }원</div>
                            {
                                v.c_option &&
                                <ul className="">
                                    {
                                        JSON.parse(v.c_option).map(options => 
                                        <li className="d-block font-weight-bold"> + {options.name} : {comma(options.price)}  </li>)
                                    }
                                </ul>
                            }
                    </div>
                </div>)
            }
            <div className="r_b_border mb-4">
                <h3 className="font-weight-bold mb-3">예약정보</h3>
            </div>
            <div className="row r_mb_down p-0">
                <div className="col-3 pl-0">
                    <span className="font-weight-bold d-block r_s_size">예약일</span>
                    <span className="d-none" id="s_tel"></span>
                </div>
                <div className="col-9">
                    <div id="si_date" className="text-right">{date}</div>
                </div>
            </div>
            <div className="row r_b_border mb-4 p-0">
                <h3 className="font-weight-bold mb-3">금액정보</h3>
            </div>
            <div className="row p-0">
                <div className="col-4 pl-0">
                    <span className="font-weight-bold d-block r_s_size">서비스명</span>
                </div>
                <div className="col-8">
                    <div className="mb-3 text-right"><span className="font-weight-bold" id="service_price">{s_cate}</span></div>
                </div>
            </div>
            {
                discount &&
                <>
                <hr className="r_mg_top_none"/>
                <div className="row p-0">
                        <div className="col-4 pl-0">
                            <span className="font-weight-bold d-block r_s_size">할인금액</span>
                        </div>
                        <div className="col-8">
                            <div className="mb-3 text-right"><span className="font-weight-bold text-danger"> - {comma(discount)}원</span></div>
                        </div>
                </div>
                </>
            }
            <hr className="r_mg_top_none" />
            <div className="row r_mbdown p-0">
                <div className="col-3 pl-0">
                    <span className="font-weight-bold d-block r_s_size r_nowrap">총 결제 금액</span>
                </div>
                <div className="col-9">
                    <div className="r_r_color font-weight-bold text-right r_s_size" id="totalPrice">{str && totalPrice(str,discount)}원</div>
                </div>

            </div>
        </>

    )
}

function Si_reserve_detail({ history, location }) {
    const session = JSON.parse(window.sessionStorage.result);
    const { u_type, u_id,u_sigong } = session;

    const query = queryString.parse(location.search);
    let r_id = query.r_id;
    let date = query.date;
    const [data, setData] = useState([]);
    const [si_data, setSiData] = useState([]);
    // const [isTitle, setTitle] = useState('신청내역 확인');
    const [r_status, setStatus] = useState('');

    //계약번호
    const [c_num, setNum] = useState('');
    const [discount, setDiscount] = useState('');
    const [cateText,setCate] = useState('');

    let obj = { r_id: r_id }
    useEffect(() => {
        const fetchData = async () => {
            instance.post('/reserve/r_id', obj).then(function (res) {
                setCate(JSON.parse(res.data[0].s_id)[0].s_cate);
                setData(res.data[0]);
                setStatus(res.data[0].r_status);
                setNum(res.data[0].contract_num);
                if(res.data[0].contract_num){
                    instance.post('/contract/num',{contract_num:res.data[0].contract_num}).then(function(res){
                    
                        setDiscount(res.data[0].co_discount)
                    });
                }
            });

        };
        fetchData();
    }, []);

    const goPage = () => {
        history.push('/customerinfo?r_id='+r_id);
    }

    return (
        <>
            <Container className="mb-5">
                <div className="c_pad mt-5">
                    {/* <TopTitle title={isTitle} /> */}
                    {/* <SigongId si_id={si_id} setSiData={setSiData} si_data={si_data}/> */}

                    <ServiceId
                        data={data}
                        u_type={u_type}
                        date={date}
                        discount={discount}
                    />
                    {
                        c_num
                        ?
                        <>
                        <div className="row mb-2 p-0">
                            <div className="col-6 pl-0 text-center">
                                <span className="btn btn-outline-secondary r_btnsize">노쇼</span>
                            </div>
                            <div className="col-6 pr-0 text-center">
                                <span className="btn btn-primary r_btnsize">시공사 취소</span>
                            </div>
                        </div>
                        <div className="row mt-3 p-0">
                            <span className="col-12 px-0 btn btn-primary r_btnsize" onClick={goPage}>작업내역등록</span>
                        </div>
                        </>
                        :
                        cateText === '썬가드하이퍼이벤트'
                            ?
                            <>
                            <div className="row mb-2 p-0">
                                <div className="col-6 pl-0 text-center">
                                    <span className="btn btn-outline-secondary r_btnsize">노쇼</span>
                                </div>
                                <div className="col-6 pr-0 text-center">
                                    <span className="btn btn-primary r_btnsize">시공사 취소</span>
                                </div>
                            </div>
                            <div className="row mt-3 p-0">
                                <span className="col-12 px-0 btn btn-primary r_btnsize" onClick={goPage}>작업내역등록</span>
                            </div>
                            </>
                            :
                            <>
                            <div className="row mt-3 p-0">
                                <span className="col-12 px-0 btn btn-primary r_btnsize" onClick={() => history.push('/repInsert?r_id='+r_id+'&date='+date+'&si_id='+u_sigong)}>프로모션 인증(계약번호 인증)</span>
                            </div>
                            </>
                    }
                    
                </div>
                <Bottom_menu />
            </Container>

        </>

    )
}

export default Si_reserve_detail